import { AxiosError } from 'axios';
import { f7 } from 'framework7-react';
import { useState } from 'react';
import { customerInfoApi } from '@/api/customerApi';
import { stopRestartHouseprepaidApi } from '@/api/prepaidApi';
import { refreshPrepaidRestrictionAfterRejectedOperation } from '@/hooks/usePrepaidRestrictionGuard';
import { useToast } from '@/hooks/useToast';
import {
  StopRestartHouseprepaidParams,
  StopRestartHouseprepaidResponse,
} from '@/types/api/prepaidApi';
import { createCustomerInfoRestrictionUpdate } from '@/utils/prepaidRestrictionRequest';
import { storeDispatch } from '@/utils/store';
import { f7CustomBack } from '@/utils/utils';

export const useHouseprepaidStopRestart = () => {
  const [data, setDate] = useState<StopRestartHouseprepaidResponse['data']>();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<AxiosError>();
  const { openToast } = useToast();
  const stopRestartHouseprepaid = async (
    params: StopRestartHouseprepaidParams,
  ) => {
    let wasStopped = false;
    try {
      f7.preloader.show();
      setIsLoading(true);
      const data = await stopRestartHouseprepaidApi(params);
      setDate(data.data);
      if (data.data.success) {
        wasStopped = true;
        const { data: basicInfo } = await customerInfoApi({
          m_customer_id: params.m_customer_id,
        });
        const { prepaids } = basicInfo;
        const restrictionUpdate = basicInfo.success
          ? createCustomerInfoRestrictionUpdate(basicInfo.customer)
          : undefined;
        if (restrictionUpdate) {
          await storeDispatch(
            'setCustomerInfo',
            'customerInfo',
            restrictionUpdate,
          );
        } else {
          await refreshPrepaidRestrictionAfterRejectedOperation(
            params.m_customer_id,
          );
        }
        storeDispatch(
          'setAdvancePaymentsInfo',
          'advancePaymentsInfo',
          prepaids,
        );
        openToast('積み立てを停止しました', 'toast-success', 3000, true, 'top');
        f7CustomBack(['#PrepaidStop']);
      } else {
        openToast('失敗しました', 'toast-failed', 3000, true, 'top');
      }
    } catch (err) {
      setError(err as AxiosError);
      if (wasStopped) {
        await refreshPrepaidRestrictionAfterRejectedOperation(
          params.m_customer_id,
        );
      }
    } finally {
      setIsLoading(false);
      f7.preloader.hide();
    }
  };

  return {
    stopRestartHouseprepaid,
    data,
    isLoading,
    error,
  };
};
